import RoleLogin from "../auth/RoleLogin";

export default function SellerLogin() {
  return (
    <RoleLogin
      role="seller"
      variant="seller"
      title="Seller sign in"
      lead="Your seller messages stay on the seller path — never mixed with a buyer checklist."
      successPath="/seller/home"
      links={[
        { to: "/register?role=seller", label: "Create seller account" },
        { to: "/login", label: "Buyer sign in" },
        { to: "/seller/home", label: "Seller portfolio" },
      ]}
    />
  );
}
